import {useTranslation} from 'react-i18next';
import LineChart from '../shared/charts/LineChart';

const OrderProgressGraph = ({plannedData = [], actualData = [], predictionData = []}) => {
  const {t} = useTranslation();
  if (plannedData.length && actualData.length) {
    actualData.unshift(plannedData[0]);
  }

  const options = {
    chart: {},
    title: {
      text: t('orderProgressWidget.graph.title'),
    },
    yAxis: {
      title: {
        text: t('orderProgressWidget.graph.yAxisTitle'),
      },
    },
    xAxis: {
      type: 'datetime',
      endOnTick: true,
      tickAmount: 4,
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
    },
    plotOptions: {
      series: {
        marker: {
          enabledThreshold: 1,
        },
      },
    },
    series: [
      {
        name: t('orderProgressWidget.graph.planned'),
        data: plannedData,
        label: false,
      },
      {
        name: t('orderProgressWidget.graph.actual'),
        data: actualData,
        label: false,
      },
      {
        name: t('orderProgressWidget.graph.prediction'),
        data: predictionData,
        color: 'red',
        label: false,
      },
    ],
  };

  return <LineChart isTimeseries options={options} showIsEmpty={!plannedData.length}/>;
};

export default OrderProgressGraph;
